import type { NextWebVitalsMetric } from 'next/app';

import { logger } from '@sravni/server-utils/lib/logger';

import { BFF_PROXY_API } from '@src/shared/constants/apiRoutes';
import client from '@src/utils/client';

export const sendWebVitals = (metrics: NextWebVitalsMetric): void => {
  try {
    client.post(BFF_PROXY_API.webVitalsRoute, {
      metrics,
      // @ts-ignore
      product: window.__NEXT_REDUX_STORE__?.getState()?.config?.name,
    });
  } catch (error) {
    logger.error({ message: 'Не удалось отправить данные о производительности' });
  }
};
